// extracted by mini-css-extract-plugin
module.exports = {"navLink":"xL","headerButton":"xM","navLinkWhileSearching":"xN","borderLink":"xO"};